<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/profileSetting" class="vx-row">
            <feather-icon icon="ArrowLeft" svgClasses="text-dark" />
            <h3>Back</h3>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="chart-container">
      <h3>Customer Edit Profile</h3>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="First Name"
              placeholder="Enter First Name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.firstName"
              class="left-width"
              clearable
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Last Name"
              placeholder="Enter Last Name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.lastName"
              class="right-width"
              clearable
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="Email Address"
              placeholder="Enter Email Address"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.email"
              class="left-width"
              clearable
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Mobile Number"
              placeholder="Enter Mobile Number"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.number"
              class="right-width"
              clearable
            />
          </vs-col>
        </vs-row>
      </vs-col>

      <div class="button_content">
        <vs-button class="button2" @click="handleSubmit">
          Update Details
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import { searchCustomerId, editcustomer } from "@/services/dashboard";
export default {
  data() {
    return {
      loading: false,
      form: {
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        email: "",
        number: "",
        address: "",
        city: "",
        state: "",
        balanceamount: "",
        country: "",
        postCode: "",
        stbNumber: "",
        planName: "",
        expiryDate: "",
        planAmount: "",
        voucherCode: "",
        movieList: "",
        movieAmount: "",
        voucherId: "",
        accountNo: "",
        movieListValue: ""
      },
      firstname: JSON.parse(localStorage.getItem("in:profile")).firstname,
      lastname: JSON.parse(localStorage.getItem("in:profile")).lastname,
      email: JSON.parse(localStorage.getItem("in:profile")).email,
      phone: JSON.parse(localStorage.getItem("in:profile")).phone,
      form: {
        contactinfo: {
          id: "",
          email: JSON.parse(localStorage.getItem("in:profile")).email,
          faxnbr: "",
          mobilephone: JSON.parse(localStorage.getItem("in:profile")).phone
        },

        middlename: "",
        infoAddress: []
      }
    };
  },
  computed: {
    ...mapState("auth", ["userInfo"])
  },
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    }
  },
  components: {
    moment
  },
  methods: {
    async myFunction() {
      try {
        const response = await searchCustomerId(this.userInfo.clientId);
        this.clientId = response.data.id;
        this.customers = response.data;
        console.log("mounted", this.form.accountNo);
        this.show = true;
        this.form = {
          title: this.customers.title,
          firstName: this.customers.firstname,
          lastName: this.customers.lastname,
          price: this.customers.orderData[0].price,
          id: this.customers.orderData[0].id,
          balanceamount: this.customers.balanceAmount,
          email: this.customers.email,
          number: this.customers.phone,
          address: this.customers.address,
          city: this.customers.city,
          state: this.customers.state,
          country: this.customers.country,
          postCode: this.customers.zip,
          stbNumber: this.customers.hwSerialNumber,
          planName: this.customers.orderData[0].planDescription,
          planAmount: this.customers.planamount,
          accountNo: this.customers.accountNo
        };
      } catch (err) {
        console.log(err);
      }
    },
    getFormattedDate(timeStamp) {
      let date;
      if (timeStamp !== undefined)
        date = timeStamp[0] + "-" + timeStamp[1] + "-" + timeStamp[2];
      return moment(date).format("MMM Do YYYY");
    },
    getDate(timeStamp) {
      let date;
      if (timeStamp !== undefined)
        date = timeStamp[0] + "-" + timeStamp[1] + "-" + timeStamp[2];
      return moment(date).format("DD MMMM YYYY");
    },
    async handleSubmit() {
      try {
        this.loading = true;
        var date = this.getDate(
          JSON.parse(localStorage.getItem("in:profile")).activationDate
        );
        const payload = {
          firstname: this.form.firstName,
          lastname: this.form.lastName,
          active: true,
          accountNo: this.userInfo.clientData.accountNo,
          email: this.form.email,
          phone: this.form.number,
          homePhoneNumber: "",
          clientCategory: JSON.parse(localStorage.getItem("in:profile"))
            .clientCategory,
          title: JSON.parse(localStorage.getItem("in:profile")).title,
          officeId: JSON.parse(localStorage.getItem("in:profile")).officeId,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          addressNo: JSON.parse(localStorage.getItem("in:user")).clientData
            .address,
          street: "",
          city: JSON.parse(localStorage.getItem("in:profile")).city,
          district: "",
          state: JSON.parse(localStorage.getItem("in:profile")).state,
          country: JSON.parse(localStorage.getItem("in:profile")).country,
          activationDate: date
        };
        console.log("form", payload);
        const result = await editcustomer(payload, this.userInfo.clientId);
        this.$router.push(`/`);
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    userInfo() {
      this.setForm();
    }
  },
  mounted() {
    this.myFunction();
  }
};
</script>

<style>
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}

.button_content {
  display: flex;
  justify-content: space-evenly;
}
.button2 {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 20px;
}
.right-width {
  width: 440px;
  border-radius: 4px;
}
.left-width {
  width: 430px;
  border-radius: 4px;
}
.v-select {
  width: 420px;
}
</style>
